module.exports = __webpack_public_path__ + "static/img/far2_active.81d4ecaa.png";